<template>
    <div id="loading">
        <h3>Carregando dados...</h3>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    h3{
        font-size: 25px;
    }
</style>